// extracted by mini-css-extract-plugin
export var marginNegative = "_7p-5 _7p-3 _7p-1";
export var marginPositive = "_7p-4 _7p-3 _7p-1";
export var modalContent = "_7p-6";
export var samplesTable = "_7p-8";
export var samplesTableContainer = "_7p-7";
export var statBox = "_7p-a";
export var tableCell = "_7p-1";
export var tableCellCenter = "_7p-2 _7p-1";
export var tableCellRight = "_7p-3 _7p-1";
export var tableHeader = "_7p-0";
export var trackingNumber = "_7p-9";